// mui
import { Typography, Stack, TableContainer, Table, TableRow, TableBody, TableCell, Skeleton } from '@mui/material';

import { Flag } from '../internal.js';
import { storage } from '@goldblack/client-storage';

function FilterDesc(props) {
    const showFlag = (index, desc) => {
        let code = desc.substring(1, 3);
        let remain = desc.substring(3, desc.length);
        let arr = [];
        arr.push(Flag(index, code));
        if (remain) {
            arr.push(showTypography(index + 1, remain, 0));
        }
        return arr;
    };

    const showTypography = (index, desc, ml) => {
        return (
            <Typography key={index} sx={{ fontSize: '14px', ml: `${ml}px` }}>
                {desc}
            </Typography>
        );
    };

    const showStringWithFlag = (key, desc) => {
        let splits = desc.split(/[\s]+/);
        return (
            <Stack key={key} direction='row' alignItems='center' justifyContent='flex-end' gap={1}>
                {splits.map((x, index) => (x.includes('^') ? showFlag(index, x) : showTypography(index, x, 0)))}
            </Stack>
        );
    };

    const showString = (desc) => {
        return (
            <Typography
                sx={{
                    fontSize: '14px',
                    width: '100%',
                    overflow: 'hidden',
                    textWrap: 'noWrap',
                    textOverflow: 'ellipsis',
                    textAlign: 'right',
                }}>
                {desc}
            </Typography>
        );
    };

    const showDesc = (key, desc) => {
        return desc.includes('^') ? showStringWithFlag(key, desc) : showString(desc);
    };

    const showLoadingSkeleton = () => {
        const config = storage.localStorage.getValue('config');
        const count = config?.data?.profileFilterLength;
        return Array.from({ length: count }, (_, i) => (
            <TableRow key={i}>
                <TableCell sx={{ p: 0, fontSize: '14px', borderBottom: 'none', color: 'primary.main' }}>
                    <Skeleton sx={{ mr: 1 }} variant='rectangular' height={20} />
                </TableCell>
                <TableCell align='right' sx={{ p: 0, borderBottom: 'none', color: 'secondary.main' }}>
                    <Skeleton sx={{ ml: 1 }} variant='rectangular' height={20} />
                </TableCell>
            </TableRow>
        ));
    };

    return (
        <TableContainer sx={{ m: 0, p: '8px' }}>
            <Table padding='checkbox'>
                <TableBody>
                    {props.loading
                        ? showLoadingSkeleton()
                        : props.filterDesc &&
                          Object.keys(props.filterDesc).map((key) => (
                              <TableRow key={key}>
                                  <TableCell
                                      sx={{
                                          p: 0,
                                          fontSize: '14px',
                                          borderBottom: 'none',
                                          color: 'primary.main',
                                      }}>
                                      {key}{' '}
                                  </TableCell>
                                  <TableCell align='right' sx={{ p: 0, borderBottom: 'none', color: 'secondary.main' }}>
                                      {showDesc(key, props.filterDesc[key])}
                                  </TableCell>
                              </TableRow>
                          ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export { FilterDesc };
